import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const SubproductEmptyState = {
  subproducts: [],
  selectedSubproduct: null,
  selectedSubproductMultiple: [],
};

export const SubproductKey = 'subproducts';

export const subproductsSlice = createSlice({
  name: 'subproducts',
  initialState: getLocalStorage(LocalStorageTypes.SUBPRODUCTS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.SUBPRODUCTS))
    : SubproductEmptyState,
  reducers: {
    setSubproducts: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.SUBPRODUCTS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedSubproduct: (state, action) => {
      const result = { ...state, selectedSubproduct: action.payload };
      persistLocalStorage(SubproductKey, result);
      return result;
    },
    updateSelectedSubproductMultiple: (state, action) => {
      const result = { ...state, selectedSubproductMultiple: action.payload };
      persistLocalStorage(SubproductKey, result);
      return result;
    },
    resetSubproducts: () => {
      clearLocalStorage('subproducts');
      return SubproductEmptyState;
    },
  },
});

export const {
  setSubproducts,
  updateSelectedSubproduct,
  updateSelectedSubproductMultiple,
  resetSubproducts,
} = subproductsSlice.actions;
